<!-- OrderDetailBody.vuefield-line -->
<template>
    <div class="page">
        <div class="common-header-wrap">
            <mt-header :title="$t('Gift Card Recycling')" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <div class="text">
            <div class="h1">{{ $t('Amazon GIFT CARD') }}</div>
            <div class="h2">{{ $t('High Priced Recycling') }}</div>
        </div>

        <div class="order-body">
            <div class="main-content">
                <flex-line class="field-line" :show-border="true">
                    <div class="field-name">{{ $t('Card number') }}</div>
                    <div class="field-line-right" slot="right">
                        <div v-if="bind_flag">{{ save_info.card }}</div>
                        <input class="field-input" v-model="save_info.card"
                            :placeholder="$t('Please enter the card number')" @blur="bind" v-else />
                        <div class="edit" v-if="bind_flag" @click="bind_flag = false">Edit</div>
                    </div>
                </flex-line>
                <flex-line class="field-line" :show-border="true">
                    <span class="field-name">{{ $t('Activation code') }}</span>
                    <div class="field-line-right" slot="right">
                        <input class="field-input" v-model="save_info.code"
                            :placeholder="$t('Please enter the activation code')" />
                    </div>
                </flex-line>
            </div>
            <div class="common-btn ds-button-large" @click="giftSave">{{ $t('Confirm Recycling') }}</div>
        </div>
    </div>
</template>
  
<script>
import { Toast, MessageBox } from 'mint-ui'
import { BindGift, GiftSave } from '../../../api/memberOrder'
import flexLine from '../../flexLine'

export default {
    name: 'MemberOrderDetail',
    data() {
        return {
            order_info: {},
            rec_id: 0,
            popupRefund: false,
            save_info: {
                card: '',
                code: '',
            },
            bind_flag: false,
        }
    },
    components: {
        flexLine
    },
    created: function () {
    },
    methods: {
        bind() {
            if (this.save_info.card == '') return;
            BindGift(this.save_info.card).then(res => {
                if (res.code == 10000) {
                    this.bind_flag = true
                } else {
                    Toast(res.message)
                    this.save_info.card = ''
                }
            })
        },
        giftSave() {
            let that = this;

            if (that.save_info.card === '') {
                Toast(that.$t('Please enter the card number'));
                return;
            }
            if (that.save_info.code === '') {
                Toast(that.$t('Please enter the activation code'));
                return;
            }
            MessageBox({
                title: that.$t('MessageBox.Tips'),
                message: that.$t('MessageBox.recycle.gift'),
                confirmButtonText: that.$t('MessageBox.Confirm'),
                cancelButtonText: that.$t('MessageBox.Cancel'),
                showCancelButton: true
            }).then(action => {
                if (action == 'confirm') {
                    GiftSave(that.save_info.card, that.save_info.code).then(res => {
                        Toast(res.message);
                        if (res.code == 10000) {
                            setTimeout(() => {
                                that.$router.push({ name: 'GiftBoxList', query: { state: 1 } });
                            }, 1000);
                        }
                    }).catch(function (error) {
                        Toast(error.message);
                    });
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.ds-button-large {
    width: 183px;
    height: 50px;
    line-height: 50px;
    background: #E7010C;
    border-radius: 6px 6px 6px 6px;
    margin: 32px;
}

.page {
    overflow: hidden;
    width: 100%;

    background: #fff;
    background-image: url('../../../assets/image/home/gift.png');
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;

    .text {
        font-size: 27px;
        color: #A62C22;
        margin: 1rem 0;
        padding: 0 24px;

        .h1 {
            font-weight: 600;
            margin: 14px 0;
        }

        .h2 {
            font-size: 20px;
        }
    }

    ::v-deep .flex-line {
        background: transparent;
        padding: 8px 16px;
        align-items: flex-start;
        flex-direction: column;

        .left {
            .field-name {
                width: 10rem;
            }
        }

        .right {
            margin-top: 20px;
            width: 100%;
        }

        .field-line-right {
            width: 100%;
            padding: 24px 15px;
            border-radius: 15px;
            border: 1px solid rgba(230, 127, 84, .5);
            justify-content: space-between;
            background: #fff;
        }

        .field-input {
            text-align: left;
        }
    }
}

.main-content {
    background: transparent;
    padding: 0 $pageSpace;
}

.common-header-wrap .common-header {
    box-shadow: unset;
    background: transparent;
}

.common-popup-content {
    padding: 0 $pageSpace;
    box-sizing: border-box
}

.order-body {
    border-radius: 25px;
    padding: 20px 0;
    overflow: auto;
    // height: 100%;
    position: absolute;
    width: 40%;
    left: 1rem;
    background: transparent;

    .desc {
        .container {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            background-color: #fff;
            padding: .25rem 0;
        }

        .title {
            width: 5rem;
            font-size: $subFontSize;
            color: #333;
            margin-left: 0.6rem;
        }

        .subtitle {
            flex: 1;
            margin-left: 1rem;
            margin-right: 0.6rem;
            color: $primaryColor;
            font-size: $subFontSize;
            text-align: right;
        }
    }

}

.order_state {
    background: $primaryColor;
    height: 3.5rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    i {
        color: #fff;
        font-size: 1.2rem;
        padding: 0 0.5rem;
    }

    span {
        font-size: $h2;
        color: #fff;
    }
}

.containers {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #fff;
    border-bottom: 1px solid #e8eaed;
}

.photo {
    width: 4rem;
    height: 4rem;
    margin: 0.75rem 0.5rem 0.75rem 0.75rem;
    border: 1px solid #e8eaed;
    flex-basis: 4rem;
    flex-shrink: 0;
}

.right-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding: 0 0.75rem 0 0;
    width: 100%;
    overflow: hidden;

    .title {
        margin-top: 0.75rem;
        color: #333;
        font-size: $subFontSize;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .property {
        font-size: $fontSize;
        color: #7c7f88;
        padding-top: 0.5rem;
    }

    .desc-wrapper {
        height: 1rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top: 1rem;

        .price {
            color: $primaryColor;
            font-size: $h2;
            margin-left: 0;
        }

        .btn-list {
            display: flex;

            .default {
                margin: 0 .1rem;
            }
        }

        .count {
            margin-top: 0.2rem;
            color: #7c7f88;
            font-size: $fontSize;
            margin: 0 0.5rem;

        }
    }
}

.address {
    height: 4.4rem;
    background-color: #fff;
    margin-bottom: 0.5rem;

    div {
        padding: 0.5rem 0.5rem 0;
    }

    img {
        height: 0.8rem;
    }

    span {
        color: #333;
        font-size: $h2;

        &.mobile {
            padding-left: 1rem;
        }
    }

    p {
        margin: 0.25rem 0.9rem 0.5rem 0.5rem;
        font-size: $subFontSize;
        color: #7c7f88;

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
}

.contact {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 2.3rem;
    background-color: #fff;
    margin-top: 0.4rem;
    border-bottom: 1px solid #e8eaed;
    padding: 0 0.65rem;

    span {
        font-size: $fontSize;
        color: #333;
        padding-right: 0.3rem;
    }

    img {
        width: 0.6rem;
        height: 0.65rem;
    }
}

.detail {
    display: flex;
    flex-direction: column;
    font-size: $subFontSize;
    color: #7c7f88;
    background-color: #fff;
    margin: 0.4rem 0;
    box-sizing: border-box;

    .number {
        padding: 0.7rem 0.8rem;
        border-bottom: 1px solid #e8eaed;

        p {
            padding-top: 0.3rem;
            font-size: $subFontSize;
        }

        button {
            color: #7c7f88;
            height: 1rem;
            background-color: #fff;
            border: 1px solid #7c7f88;
            width: 2.7rem;
            height: 1rem;
            border-radius: 0.1rem;
            font-size: $subFontSize;
        }
    }

    .pay {
        border-bottom: 1px solid #e8eaed;
        padding: 0.7rem 0.8rem;
    }

    .givetime {
        padding: 0.7rem 0.8rem;
        font-size: $subFontSize;
    }

    input {
        background-color: #fff;
        border: 1px solid #7c7f88;
    }
}

.desc {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding-top: 0.6rem;
    box-sizing: border-box;
    margin-bottom: 4rem;

    .desc-item {
        flex: 1;
        margin-top: 0.5rem;
    }

    .amount {
        display: flex;
        justify-content: flex-end;
        font-size: $subFontSize;
        color: #333;
        padding-right: 0.75rem;
        border-top: 1px solid #e8eaed;
        margin-top: 0.6rem;
        height: 2.2rem;
        line-height: 2.2rem;

        span {
            font-size: $h2;
            color: $primaryColor;
        }
    }
}

.ship {
    margin-bottom: 0;
}

.order_store {
    background: #fff;
    height: 1rem;
    line-height: 1rem;
    padding: 0.5rem 0.8rem;
    border-bottom: 1px solid #f5f5f5
}

.order_store span {
    color: #333;
    font-size: $subFontSize;
    font-weight: 600;
    float: left;
    margin: 0 0.4rem;
}

.order_store i.store {
    float: left
}

.order_store i.more {
    float: left;
    font-size: $subFontSize;
}

.pickup-code {
    font-size: $fontSize;
    color: #fff
}
</style>

<!-- 字体图标样式覆盖 -->
<style lang="scss">
.mint-toast-icon {
    font-size: 1.9rem;
}

button {
    padding: 0;
}

.ds-button-large {
    margin: 0 $pageSpace;
}
</style>
